import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";

@Component({
    selector: "app-models-dialog",
    imports: [SharedMaterialModule, SharedDsnModule],
    templateUrl: "./models-dialog.component.html",
    styleUrl: "./models-dialog.component.scss",
})
export class ModelsDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<ModelsDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: ImageInputType
    ) {}

    ngOnInit(): void {}
}

type ImageInputType = {
    title: string;
    description: string;
    image: {
        src: string;
        height: number;
        width: number;
    };
};
